import Shared from './shared_constants';
import 'jquery-migrate';
import $ from 'jquery';
import cookies from 'js-cookie';

/** Make Hubs global for inline JavaScript */
window.Shared = Shared;

/** Set window of Iframe as root */
Shared.root = window;

/* ******************************************************************************************** */
/* * Custom Exception Handling                                                                * */
/* ******************************************************************************************** */

/**
 * Shared Exception Wrapper
 *
 * @public
 * @this local
 * @param {String} msg The message of the Exception
 * @return {Mixed} A jQuery Object containing a Handle to the DOM Elements specified by the selector
 */
Shared.Exception = function(msg, args) {
    this.name = 'Shared.Exception';
    this.type = Shared.LVL_ERROR;
    this.msg  = msg;
    this.args = args;
};


/* ******************************************************************************************** */
/* * String/Number Related Methods                                                            * */
/* ******************************************************************************************** */

/**
 * JavaScript HTML encode - for example, safe for picking up values from HTML attributes and using them to build up HTML via JS
 *  NOT for use within tags such as script, in the context of event handlers, etc.
 */
Shared.jhe = function(str) {
    return $('<div/>').text(str).html();
};

/**
 * Left Pads a String with a specified character
 *
 * @public
 * @this local
 * @param {String} str The string to pad with the specified or default character
 * @param {Number} max The max length of the String to Pad to; if the string is greater, return the string
 * @param {String} [padding] The character(s) to pad the string with; default padding is a single space
 * @return {String} The padded string
 */
Shared.lpad = function(str, max, padding) {
    if (padding === undefined) {padding = ' ';}
    return str.length < max ? Shared.lpad(padding + str, max, padding) : str;
};

/**
 * Right Pads a String with a specified character
 *
 * @public
 * @this local
 * @param {String} str The string to pad with the specified or default character
 * @param {Number} max The max length of the String to Pad to; if the string is greater, return the string
 * @param {String} [padding] The character(s) to pad the string with; default padding is a single space
 * @return {String} The padded string
 */
Shared.rpad = function(str, max, padding) {
    if (padding === undefined) {padding = ' ';}
    return str.length < max ? Shared.rpad(str + padding, max, padding) : str;
};

/**
 * Trims the whitespace from the ends of a String
 *
 * @public
 * @this local
 * @param {String} str The string to trim
 * @return {String} The trimmed string
 */
Shared.trim = function(str) {
    return str.replace(/^\s+|\s+$/g, '');
};

/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 *
 * @public
 * @this local
 * @author Jeff Ward (jcward.com)
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 * @return {String} The Unique ID
 */
Shared.getUUID = function() {
    var lut = [];
    var d0 = Math.random()*0xffffffff|0;
    var d1 = Math.random()*0xffffffff|0;
    var d2 = Math.random()*0xffffffff|0;
    var d3 = Math.random()*0xffffffff|0;
    for (var i=0; i<256; i++) { lut[i] = (i<16?'0':'')+(i).toString(16); }
    return lut[d0&0xff]+lut[d0>>8&0xff]+lut[d0>>16&0xff]+lut[d0>>24&0xff]+'-'+
            lut[d1&0xff]+lut[d1>>8&0xff]+'-'+lut[d1>>16&0x0f|0x40]+lut[d1>>24&0xff]+'-'+
            lut[d2&0x3f|0x80]+lut[d2>>8&0xff]+'-'+lut[d2>>16&0xff]+lut[d2>>24&0xff]+
            lut[d3&0xff]+lut[d3>>8&0xff]+lut[d3>>16&0xff]+lut[d3>>24&0xff];
};

/**
 * Parse a String for all URL QueryString Parameters
 *
 * @public
 * @this local
 * @return {Object} A JSON Object of all parts in URL Query String
 */
Shared.parseQueryParams = function(url) {
    var params = {};
    $.each(url.substr(1).split('&'), $.proxy(function(idx, pair) {
        if (pair === '') return;
        var parts = pair.split('=');
        this[parts[0]] = parts[1] && decodeURIComponent(parts[1].replace(/\+/g, ' '));
    }, params));
    return params;
};

/**
 * Parse a String for a URL QueryString Parameter by its Name
 *
 * @public
 * @this local
 * @return {String} The Value of the QueryString Parameter or an Empty String
 */
Shared.parseQueryParamByName = function(url, name){
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/* ******************************************************************************************** */
/* * Object Related Methods                                                                   * */
/* ******************************************************************************************** */

/**
 * Extands an existing Class with the Methods from Another Class
 *
 * @public
 * @this local
 * @param {Class} receivingClass The Class to Augment the Methods to
 * @param {Class} givingClasses An array of Classes to Augment the Methods from
 * @return undefined
 */
Shared.augment = function(receivingClass, givingClasses) {
    var i, n, methodName = null;
    for (i = 0, n = givingClasses.length; i < n; i++) {
        for (methodName in givingClasses[i].prototype) {
            if (givingClasses[i].prototype.hasOwnProperty(methodName)) {
                if (!Object.hasOwnProperty(receivingClass.prototype, methodName)) {
                    receivingClass.prototype[methodName] = givingClasses[i].prototype[methodName];
                }
            }
        }
    }
};


/* ******************************************************************************************** */
/* * Browser Related Methods (Shims)                                                          * */
/* ******************************************************************************************** */

Shared.setCookie = function(itemName, itemValue, options) {
    options = options || {};
    if ($.cookie !== undefined) {
        cookies.set(itemName, itemValue, options);
    }
};

Shared.getCookie = function(itemName) {
    if ($.cookie !== undefined) {
        return cookies.get(itemName);
    }
};

/**
 * Gets the Current Time as a Timestamp
 *
 * @public
 * @this local
 * @return {Number} Timestamp of Current Time
 */
Shared.getTime = Date.now || function() { return new Date().getTime(); };

/**
 * Executes a Function on the Browsers' Next Event Loop
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.onNextEventLoop = function(fnHandler, context, delay) {
    return Shared.root.setTimeout($.proxy(fnHandler, context || Shared), delay || 0);
};

/**
 * Parse a URL for all QueryString Parameters
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.getQueryParams = function() {
    return Shared.parseQueryParams(location.search);
};

/**
* Returns the page queries without the provided query strings
*
* @param queryNames
* @returns {undefined}
*/
Shared.getQueriesWithout = function(queryNames) {
    var queries = this.getQueryParams();
    $.each(queryNames, function (i, name) {
        delete queries[name];
    });
    return queries;
};

/**
 * Parse a URL for a QueryString Parameter by its Name
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.getQueryParamByName = function(name) {
    return Shared.parseQueryParamByName(location.search, name);
};

Shared.triggerFullscreen = function(enable, element) {
    var $controls = $('.fullscreen-controls');
    var $expand = $controls.find('.fullscreen-open');
    var $unexpand = $controls.find('.fullscreen-close');

    if (enable) {
        $controls.addClass('fullscreen');
        $expand.attr('style','display: none');
        $unexpand.attr('style','display: inline-block');
        if (element) {
            $(element).addClass('uf-fullscreen-element');
        }
    } else {
        $controls.removeClass('fullscreen');
        $expand.attr('style','display: inline-block');
        $unexpand.attr('style','display: none');
        $('.uf-fullscreen-element').removeClass('uf-fullscreen-element')
    }
};

/**
 * Push an Element into Fullscreen Mode (Defaults to the Current Document)
 *
 * @public
 * @this local
 * @param {Object} element - (Optional) The element to push into Fullscreen Mode
 * @return undefined
 */
Shared.enterFullscreen = function(element) {
    if (element === undefined) {
        element = document.documentElement;
    }
    if (element.requestFullscreen) {
        Shared.triggerFullscreen(true, element);
        element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
        Shared.triggerFullscreen(true, element);
        element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
        Shared.triggerFullscreen(true, element);
        element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
        Shared.triggerFullscreen(true, element);
        element.msRequestFullscreen();
    } else {
        return false;
    }
};

/**
 * Exit Fullscreen Mode for Current Document and any Elements within
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.exitFullscreen = function() {
    // For the purposes of this check, we only need to be concerned with these properties.
    // We may have a "fake" fullscreen element, but trying to call exitFullscreen in that case will throw an error.
    var isFullscreen = document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
    /**
     * Chrome & other modern browsers throw errors
     * if you try to exit fullscreen when you are not in fullscreen mode.
     * */
    if (!isFullscreen) {
        // If you use "esc" to exit fullscreen, we end up here (and still need to cleanup)
        Shared.triggerFullscreen(false);
        return;
    }
    if (document.exitFullscreen) {
        Shared.triggerFullscreen(false);
        document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
        Shared.triggerFullscreen(false);
        document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
        Shared.triggerFullscreen(false);
        document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
        Shared.triggerFullscreen(false);
        document.msExitFullscreen();
    } else {
        return false;
    }
};

/**
 * Check if the Browser is in Fullscreen Mode
 *
 * @public
 * @this local
 * @return {boolean}
 */
Shared.isBrowserFullscreen = function() {
    var fs = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    return (!!fs);
};

/**
 * Check if the Browser is in Fullscreen Mode
 *
 * @public
 * @this local
 * @return {string}
 */
Shared.isPseudoFullscreen = function() {
    return Shared.$('body').hasClass('pseudo-fullscreen');
};

/* ******************************************************************************************** */
/* * Template Rendering Methods                                                               * */
/* ******************************************************************************************** */

/**
 * Inserts a JS Resource into the Page, and fires a callback once it is loaded
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.insertJS = function(url, callback) {
    var js = document.createElement('script');
    js.id = 'injected-js-' + Shared.getTime();
    js.async = 0; js.src = url;
    js.onreadystatechange = js.onload = function() {
        var state = js.readyState;
        if (!callback.done && (!state || /loaded|complete/.test(state))) {
            callback.done = true;
            callback.call(null, js.id);
        }
    };
    document.getElementsByTagName('head')[0].appendChild(js);
};

/* ******************************************************************************************** */
/* * DOM Element Related Methods                                                              * */
/* ******************************************************************************************** */

/**
 * Gets a Handle to a jQuery DOM Element and caches the Handle
 *      - if the Handle exists in subsequent calls, it returns the cached Handle
 *
 * @public
 * @this local
 * @param {String} selector A string containing a valid CSS Selector used to find elements in the DOM
 * @return {Mixed} A jQuery Object containing a Handle to the DOM Elements specified by the selector
 */
Shared.$ = function(selector) {
    var $el = null, objs = {'top': top, 'window': window, 'document': document};
    if (typeof selector === 'string') {
        if (Shared.ElementBank[selector] === undefined || Shared.ElementBank[selector].length < 1) {
            if (objs[selector] !== undefined) {
                Shared.ElementBank[selector] = $(objs[selector]);
            } else {
                Shared.ElementBank[selector] = $(selector);
            }
        }
        $el = Shared.ElementBank[selector];
    } else {
        $el = $(selector);
    }
    return $el;
};

/**
 * Scroll the Body Element to a Pixel-Based Coordinate
 *  - Standarized method for Scrolling that works in all Browsers/Devices
 *
 * @public
 * @this local
 * @param {Number} top - The amount of Pixels to Scroll the Element by; If not supplied, will return the Current Value of "scrollTop"
 * @param {Number} animateSpeed - The speed of the Animation to use; if not set no animation will be used
 * @param {Object} $el - a jQuery Element Handle to the Element to be Scrolled; Defaults to "window"
 * @return undefined
 */
Shared.scrollTop = function(top, animateSpeed, $el) {
    // Ensure Element was Scrolled
    //  - Chrome on Mac has some strange scroll problem
    var ensureScrolling = function() {
        Shared.onNextEventLoop(function() {
            if ($el.scrollTop() !== top && 'scroll' in window) {
                window.scroll(0, top);
            }
        });
    };

    // Get Scroll Element
    $el = $el || Shared.$('window');
    // Make sure that object is jquery instance
    $el = $($el);

    // Get Scroll-Top of Element
    if (top === undefined || top === null) {
        return $el.scrollTop();
    }

    // Perform Scrolling in next Browser Event Loop
    Shared.onNextEventLoop(function() {
        if (animateSpeed && animateSpeed > 0 && $el[0] !== window) {
            $el.animate({'scrollTop': top}, animateSpeed, ensureScrolling);
        } else {
            $el.scrollTop(top);
            ensureScrolling();
        }
    }, this, 10);
};

/**
 * Animates an Element using CSS3 Transitions or Fallback to jQuery Animations if not supported
 *
 * @public
 * @this local
 * @param {Object} element A jQuery Element to Animate
 * @param {Object} props The Properties of the Element to Animate
 * @param {Number} [duration] The duration of the animation in Milliseconds only
 * @param {Function} [callback] A callback function to execute once the animation has completed
 * @return undefined
 */
Shared.animate = function($element, props, duration, callback) {
    if ($element.transition !== undefined) {
        $element.transition(props, duration, 'in', callback);
    } else {
        $element.animate(props, duration, 'swing', callback);
    }
};

/**
 * Enables Hover Menus for Elements
 *   - Menu may be nested within Hover Element, or a completely separate element
 *
 * @public
 * @this local
 * @param {Object} options
 * @return undefined
 */
Shared.enableHoverMenu = function(options) {
    var elementHoverFunc, menuHoverFunc;

    // Check for Required Hover Element
    if (options.hover !== undefined) {
        options.hover = $(options.hover);
    }
    if (!options.hover && !options.hover.length) { return; }

    // Create Closed Hover Function for Hover Events
    elementHoverFunc = function(opts) {
        return function(e) {
            var $menuEl, timer = 0;

            // Get Menu Element
            if (opts.menu !== undefined) {
                if (typeof opts.menu === 'function') {
                    $menuEl = opts.menu(e, opts);
                } else {
                    $menuEl = $(opts.menu);
                }
            } else {
                $menuEl = $(e.currentTarget);
            }

            // Set Timer for Menu
            timer = $menuEl.data('hoverTimer');

            if (e.type === 'mouseenter') {
                // Handle Timer of Hover
                if (timer && timer > 0) {
                    window.clearTimeout(timer);
                    $menuEl.data('hoverTimer', 0);
                }

                // Call Hover-Over Callback
                if (typeof opts.hoverOverCallback === 'function') {
                    opts.hoverOverCallback(e, $menuEl);
                }

                // Apply Hover Class to Menu Element
                $menuEl.addClass('hover');
            } else {
                // Handle Timer of Hover
                timer = window.setTimeout(function() {
                    if (!$menuEl.data('mouseover')) {
                        $menuEl.data('hoverTimer', 0);

                        // Remove Hover Class from Menu Element
                        $menuEl.removeClass('hover');

                        // Call Hover-Out Callback
                        if (typeof opts.hoverOutCallback === 'function') {
                            opts.hoverOutCallback(e, $menuEl);
                        }
                    }
                }, 500);
                $menuEl.data('hoverTimer', timer);
            }
        };
    };

    // Attach Hover Event for Hover Element
    options.hover.on('mouseenter.Shared.Element mouseleave.Shared.Element', elementHoverFunc(options));

    // Check for Separate Menu Selector
    if (options.isSeparateMenu !== undefined) {

        // Get Menu Selector
        if (typeof options.isSeparateMenu !== 'string') {
            if (options.menu !== undefined) {
                if (typeof options.menu === 'function') {
                    options.isSeparateMenu = options.menu();
                } else {
                    options.isSeparateMenu = options.menu;
                }
            } else {
                return;
            }
        }

        // Create Closed Hover Function for Menu-Hover Events
        menuHoverFunc = function(opts) {
            return function(e) {
                var $menuEl = $(e.currentTarget), timer = 0;

                if (e.type === 'mouseenter') {
                    $menuEl.data('mouseover', true);
                } else {
                    $menuEl.data('mouseover', false);
                    timer = window.setTimeout(function() {
                        if (!$menuEl.data('mouseover')) {
                            $menuEl.data('hoverTimer', 0);

                            // Remove Hover Class from Menu Element
                            $menuEl.removeClass('hover');

                            // Call Hover-Out Callback
                            if (typeof opts.hoverOutCallback === 'function') {
                                opts.hoverOutCallback(e, $menuEl);
                            }
                        }
                    }, 500);
                    $menuEl.data('hoverTimer', timer);
                }
            };
        };

        // Attach Hover Events to Separate Menu to Prevent Premature Closing of Menu
        // - options.isSeparateMenu should be a DOM selector string if not undefined
        $('body').on('mouseenter.Shared.Body mouseleave.Shared.Body', options.isSeparateMenu, menuHoverFunc(options));
    }
};


/* ******************************************************************************************** */
/* * AJAX Related Methods                                                                     * */
/* ******************************************************************************************** */

/**
 *
 * Constructs an absolute URL to a Hub resource from a relative URL.
 *
 * @param relativePath
 * @returns {string}
 */
Shared.absoluteHubUrl = function(relativePath) {
    var baseUrl = Hubs.Config.hubBaseUrl;

    if (window.self.location.hostname === 'localhost'){
        // This allows onBrand to proxy the hub for local development
        baseUrl = window.location.protocol + '//' + window.location.hostname + (window.location.port ? (':' + window.location.port) : '');
    }

    // Remove trailing slash from base URL
    if (baseUrl.substr(-1) === '/') {
        baseUrl = baseUrl.substr(0, baseUrl.length - 1);
    }

    // Remove leading slash from relative path
    if (relativePath.substr(0, 1) === '/') {
        relativePath = relativePath.substr(1, relativePath.length - 1);
    }

    return baseUrl + '/' + relativePath;
}

/**
 * Initiates an AJAX request to the server and returns parsed JSON data via a callback
 *
 * @public
 * @this local
 * @param {String} url The URL to send an ajax request to
 * @param {Object} [data] A JSON Object of Data to send to the server
 * @param {String} [type] The Type of Request to send ('POST' or 'GET') - defaults to 'POST'
 * @param {Boolean} [parseJson] A flag indicating whether or not to Parse results as JSON
 * @param {Function} [callback] A callback function to execute once the server has return a successful result. The result data is passed as a parameter to the callback function.
 * @param {Function} [errorCallback] A callback function to execute once the server has return a failed result.  The jqXhr data is given to the function.
 * @return undefined
 */
Shared.ajaxFetch = function(url, data, type, parseJson, callback, errorCallback) {
    if (type === undefined) { type = 'POST'; }
    var uuid = Shared.getUUID();
    var cache = (type !== 'POST') && !Shared.MS_IE_10;

    var parsedUrl = Hubs.url.parse(url);
    if (parsedUrl.reference !== 'absolute' && parsedUrl.reference !== 'uri') {
        // If url is relative, prepend the Hub's base url to make it absolute.
        url = Shared.absoluteHubUrl(url);
    }

    var ajaxOptions = {
        'type'     : type,
        'url'      : url,
        'async'    : true,
        'cache'    : cache,
        'success'  : $.proxy(function(data) {
            try      { if (parseJson && typeof data === 'string') { data = JSON.parse(data); } }
            catch(e) { throw new Shared.Exception('ajax-failed-parse', {'reason': e}); }
            finally  { if (typeof callback === 'function') { callback.call(this, data); } }
        }, this),
        'error' : $.proxy(function(jqXhr, textStatus, errorThrown) {
            // Use the error callback if would be considered a non-fatal error
            if (typeof errorCallback === 'function') {
                errorCallback.call(this, jqXhr);
            } else {
                if (textStatus !== 'abort' ) {
                    throw new Shared.Exception('ajax-failed-receive', {'reason': errorThrown});
                }
            }

        }, this)
    };

    // Send Data?
    if (typeof data === 'object') {
        ajaxOptions.data = data;
    }

    // Send Ajax Request
    Shared.LastXhr[uuid] = $.ajax(ajaxOptions, this);
    return uuid;
};

/**
 * Cancels the last AJAX request to the server
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.cancelAjax = function(uuid) {
    if (uuid && Shared.LastXhr[uuid] && Shared.LastXhr[uuid].readyState !== 4) {
        Shared.LastXhr[uuid].abort();
        Shared.LastXhr[uuid] = null;
        return true;
    }
    return false;
};

/* ******************************************************************************************** */
/* * Special Event Registration                                                               * */
/* *  -- debouncedresize                                                                      * */
/* ******************************************************************************************** */

/**
 * Initialize Special Global Events
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.initSpecialEvents = function(threshold) {
    var specialEvents = [
        {'event': 'resize', 'prefix': 'debounced', 'threshold': threshold || 0}
    ];
    Shared.registerSpecialEvents(specialEvents);
};

/**
 * Register Specialized Global Events
 *
 *   [
 *      {'event': 'resize', 'prefix': 'debounced', 'threshold': 150}
 *      {'event': 'keyup',  'prefix': 'debounced', 'threshold': 250},
 *   ]
 *
 * @public
 * @this local
 * @return undefined
 */
Shared.registerSpecialEvents = function(eventsArray) {
    var i, $event = $.event;
    if (!Array.isArray(eventsArray)) { return; }

    var specialSetup = function(evd) {
        return function() {
            var $win = $(this);
            if (!$win.data('special-event-init-' + evd.event)) {
                $win.data('special-event-init-' + evd.event, true);
                $win.on(evd.event, evd.$special.handler);
            }
        };
    };
    var specialteardown = function(evd) {
        return function() {
            $(this).off(evd.event, evd.$special.handler);
        };
    };
    var specialHandler = function(evd) {
        return function(event, execAsap) {
            // Save the context
            var context = this,
                args = arguments,
                dispatch = function() {
                    // set correct event type
                    event.type = evd.prefix + evd.event;
                    $event.dispatch.apply(context, args);
                };

            if (evd.eventTimeout) {
                window.clearTimeout(evd.eventTimeout);
            }

            if (execAsap) { dispatch(); }
            else { evd.eventTimeout = window.setTimeout(dispatch, evd.$special.threshold); }
        };
    };

    // Loop through Events Array
    for (i = 0; i < eventsArray.length; i++) {
        var evd = eventsArray[i];
        evd.$special = {};
        evd.eventTimeout = 0;

        // Ensure valid Event Data
        if (evd.event === undefined || !evd.event.length) { continue; }
        if (evd.prefix === undefined || !evd.prefix.length) { evd.prefix = 'debounced'; }
        if (evd.threshold === undefined || evd.threshold < 10) { evd.threshold = 150; }

        // Avoid registering events twice
        if ($event.special[evd.prefix + evd.event]) { continue; }

        // Create Special Event Handler
        evd.$special = $event.special[evd.prefix + evd.event] = {
            'setup'     : specialSetup(evd),
            'teardown'  : specialteardown(evd),
            'handler'   : specialHandler(evd),
            'threshold' : evd.threshold
        };
    }
};

/**
 * Returns the page queries without onBrand prefixed url params
 *
 * @param queryNames
 * @returns {undefined}
 */
Shared.removeCustomCodeCommands = function(queryNames) {
    $.each(queryNames, function (key) {
        if (/ufcc_[a-zA-Z0-9_]*/g.test(key)) {
            delete queryNames[key];
        }
    });
    return queryNames;
};


/* ******************************************************************************************** */
/* * Fixes for 3rd-Party Plugins                                                              * */
/* ******************************************************************************************** */

// Fix Bindings for Older jQuery
if (typeof $.on !== 'function') { $.on = $.bind; }


/* ******************************************************************************************** */
/* * Private/Static Member Vars                                                               * */
/* ******************************************************************************************** */

/** @member {Object} ElementBank A bank of Cached jQuery Objects with handles to DOM Elements */
Shared.ElementBank = {};

/** @member {Object} LastXhr A handle to the last Ajax Request made */
Shared.LastXhr = {};

export default Shared;
